import React from 'react';
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from "@material-ui/icons/Delete";


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

const AdmissionFormTableView = props => {
    const classes = useStyles();
    const { rows, columns, onRemove } = props;

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {columns.map((column, i) => (
                            <TableCell key={i}>{column.label}</TableCell>
                        ))}
                        <TableCell align="right">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow key={index}>
                            {columns.map((column) => (
                                <TableCell key={column.key} component="th" scope="row">
                                    {row[column.key]}
                                </TableCell>
                            ))}
                            <TableCell align="right"> <IconButton onClick={(e, i = index) => onRemove(e,i)}>
                                <DeleteIcon fontSize="small" />
                            </IconButton></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {rows.length <= 0 && <Paper style={{
                display: 'flex',
                justifyContent: 'center',
                padding: 50
            }}>No Data</Paper>}
        </TableContainer >
    );
}

AdmissionFormTableView.propTypes = {
    rows: PropTypes.array,
    onRemove: PropTypes.func,
    columns: PropTypes.array
};

AdmissionFormTableView.defaultProps = {
    rows: [],
    columns: [],
    onRemove: fn => fn
};

export default AdmissionFormTableView;